module.exports = require("live/services/charts/point");